import { Minus, Plus } from "lucide-react";
import { cn } from "@/lib/utils";

/** Količina za prezentaciju: mete od 44 px, bez tipkanja — komercijalista bira prstom
 *  dok drži tablet u drugoj ruci. `sm` je uža varijanta za red varijacije na kartici,
 *  gdje puna visina ne stane, ali meta i dalje ostaje veća od prosječnog vrha prsta. */
export function Stepper({
  value,
  onChange,
  size = "lg",
  disabled = false,
  label,
  className,
}: {
  value: number;
  onChange: (n: number) => void;
  size?: "sm" | "lg";
  disabled?: boolean;
  /** Dodatak uz „Smanji/Povećaj količinu" kad je na ekranu više steppera odjednom. */
  label?: string;
  className?: string;
}) {
  const box = size === "sm" ? "h-8 w-8" : "h-11 w-11";
  const suffix = label ? ` — ${label}` : "";
  return (
    <div className={cn("flex items-center ring-1 ring-foreground/15", disabled && "opacity-40", className)}>
      <button
        type="button"
        disabled={disabled}
        onClick={() => onChange(value - 1)}
        aria-label={`Smanji količinu${suffix}`}
        className={cn("flex items-center justify-center text-muted-foreground transition-colors active:bg-muted", box)}
      >
        <Minus className={size === "sm" ? "h-3.5 w-3.5" : "h-4 w-4"} />
      </button>
      <span className={cn("text-center font-semibold tabular-nums", size === "sm" ? "min-w-7 text-sm" : "min-w-10 text-base")}>
        {value}
      </span>
      <button
        type="button"
        disabled={disabled}
        onClick={() => onChange(value + 1)}
        aria-label={`Povećaj količinu${suffix}`}
        className={cn("flex items-center justify-center text-muted-foreground transition-colors active:bg-muted", box)}
      >
        <Plus className={size === "sm" ? "h-3.5 w-3.5" : "h-4 w-4"} />
      </button>
    </div>
  );
}
